<template>
  <div>
    <h1 class="common__main-title">A Tutor’s Lesson Schedule</h1>
    <div class="common__main-contener">
      <div class="common__main-content bg-white">
        <form class="container">
          <div class="row">
            <div class="form-group col-7 mr-4">
              <label>Term</label>
              <div class="row">
                <div class="col-6">
                  <label class="mr-3" v-for="(name, type) of termTypes" :key="type">
                    <input type="radio" class="mr-1" v-model="termType" :value="type" />{{ name }}
                  </label>
                </div>
                <select class="col-6 form-control" v-model="term">
                  <option v-for="{ date, label } of terms" :key="label" :value="date">
                    {{ label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-3">
              <label>University</label>
              <SelectUniversityInput v-model="university" />
            </div>
          </div>
        </form>
        <h2 class="text-center">Lesson Schedule</h2>
        <div class="tutor-name">
          <h6 class="text-right">{{ profile && profile.name }}</h6>
        </div>
        <LessonSchedules />
      </div>
    </div>

    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash';
import moment, { Moment } from 'moment';
import { RootState } from '@/store/types';
import LessonSchedules from '@/components/parts/tutor/LessonSchedules.vue';
import SelectUniversityInput from '@/components/parts/inputItem/SelectUniversityInput.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import { lessonScheduleTermType, LessonScheduleTermTypes, TutorLessonScheduleConditions } from '@/store/mypage/types';
import { Tutor } from '@/store/tutors/types';
import { University } from '@/store/master/types';

export default Vue.extend({
  components: {
    SelectUniversityInput,
    LessonSchedules,
    Loading,
  },

  data: (): {
    isLoading: boolean
    termType: lessonScheduleTermType
    term: Moment
    university: University
    } => ({
    isLoading: false,
    termType: 'week',
    term: moment().startOf('week'),
    university: { code: '01', name: 'waseda', abbreviation: 'W' },
  }),
  computed: {
    profile(): Tutor|null {
      return (this.$store.state as RootState).auth.profile
    },
    termTypes() {
      return LessonScheduleTermTypes
    },
    terms(): { date: Moment, label: string }[] {
      const now = moment()
      if (this.termType === 'month') {
        // 月の配列作成
        const start = now.clone().startOf('month')
        return [...Array(3)].map((v, index: number): { date: Moment, label: string } => {
          const current = start.clone().add(index, 'month')
          return {
            date: current,
            label: current.format('YYYY/MM'),
          }
        })
      }

      if (this.termType === 'week') {
        // 週の配列作成
        const start = now.clone().startOf('week')
        const end = start.clone().add(3, 'month')
        const result: { date: Moment, label: string }[] = []
        for (let current = start; current < end; current = current.clone().add(1, 'week')) {
          result.push({ date: current, label: current.format('YYYY/MM/DD -') })
        }
        return result
      }

      return []
    },
  },

  created() {
    this.fetch()
  },
  watch: {
    termType() {
      if (this.termType === 'week') {
        this.term = moment().startOf('week')
      }
      if (this.termType === 'month') {
        this.term = moment().startOf('month')
      }
      this.fetch()
    },
    term() {
      this.fetch()
    },
    university() {
      this.fetch()
    },
  },
  methods: {
    fetch() {
      if (this.isLoading) {
        return
      }

      this.isLoading = true
      let conditions: TutorLessonScheduleConditions = {
        university: this.university,
      }
      if (this.termType === 'week') {
        conditions = _.set(conditions, 'week', this.term)
      }
      if (this.termType === 'month') {
        conditions = _.set(conditions, 'month', this.term)
      }

      this.$store.dispatch('fetchTutorLessonSchedule', {
        tutorId: this.$route.params.tutorId,
        conditions,
      }).finally(() => { this.isLoading = false })
    },
  },

})
</script>
